import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRightIcon } from '@bi-digital/icons';
import { ResponsiveImage, type ResponsiveImageData } from '@bino/utils/components/responsive-image';
import styles from './former-student-card.module.css';

export type FormerStudent = {
    profileImage: ResponsiveImageData | null;
    profileName: string;
    profileJobTitle: string;
    profileEmployer: string;
    levels: string[];
    academicDegrees: string[];
    url: string;
};

export const FormerStudentCard = ({ student }: { student: FormerStudent }) => {
    const { t } = useTranslation('former-students');
    const linkId = useId();

    return (
        <li className='promo-card-wrapper'>
            <div className='promo-card' data-clickdelegatefor={linkId}>
                <div className='border-hover' aria-hidden='true' />
                <div className='border-hover-corner' aria-hidden='true' />
                <div className='promo-card-media'>
                    <ResponsiveImage
                        image={student.profileImage}
                        alt=''
                        fallbackImageUrl='/public/images/employee.jpg'
                    />
                </div>
                <div className='promo-card-container'>
                    <p className='title'>
                        <a id={linkId} href={student.url}>
                            {student.profileJobTitle}
                        </a>
                    </p>
                    <p className='description'>{student.profileEmployer}</p>
                    <p className={styles.name}>{student.profileName}</p>
                    {student.academicDegrees.length > 0 && (
                        <p className={styles.academicDegree}>{student.academicDegrees.join(', ')}</p>
                    )}
                    <span className={styles.readMore} aria-hidden='true'>
                        {t('readMore')}
                        <ArrowRightIcon size='large' />
                    </span>
                </div>
            </div>
        </li>
    );
};
